import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employee-department-list',
  templateUrl: './employee-department-list.component.html',
  styleUrls: ['./employee-department-list.component.css']
})
export class EmployeeDepartmentListComponent implements OnInit {
    title: string = 'Employee Departments';
    breadcrumb: any[];

    constructor() {
        this.title = 'Employee Departments';
        this.breadcrumb = [
            {
                title: 'Home',
                link: '/',
                active: false
            },
            {
                title: 'Admin',
                active: false
            },
            {
                title: 'Employee Departments',
                active: true,
                link: '/admin/employee-department-list'
            }
        ];

    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }
}
